import { Dialog } from "@headlessui/react";

import DialogBackdrop from "./DialogBackdrop";
import { Link } from "react-router-dom";
export default function DeleteAutopayConfirmModel({
  deleteConfirmationModal,
  setDeleteConfirmationModal,
}) {
  return (
    <>
      <Dialog
        open={deleteConfirmationModal}
        onClose={() => null}
        className="ui-dialogs"
      >
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              Payment method has been successfully deleted.
            </Dialog.Title>
            <hr />
            <Dialog.Description>
              Thank you for choosing to receive a paper bill. This will take
              effect on your next billing cycle. You can expect to receive your
              bill on XX/XX/XXXX.
            </Dialog.Description>
            <div className="block text-right mt-6">
              <Link
                to="/payment/make-a-payment"
                className="ui-btn-secondary ui-btn-min-w mt-4"
              >
                Make a payment
              </Link>
              <Link
                to="/policies"
                className="ui-btn-primary ui-btn-min-w mt-4 mx-2"
              >
                Go to my policies now
              </Link>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
